<template>
<div class="page clients" v-bind:class="{init: isInit}">
  <div class="container-fluid">
    <div class="row center-xs">
      <div class="col-md-9 col-xs-12 text-center first">
        <h1>100%</h1><span>COMMITTED</span>
        <p>Across the years, we’ve partnered with brands across verticals and domains, and some even from outer space (or at least we thought so because they were so wonderful.)</p>
      </div>
    </div>
    <div class="row center-xs icons">
      <div class="col-md-9 col-xs-12">
        <h2>Clients</h2>
        <img src="../img/clients-shadow.png" />
      </div>
      <div class="col-md-9 col-xs-12">
        <div class="row">
          <div class="col-md-2 col-sm-3 col-xs-6">
            <img src="../img/clients-icon-37.png" />
          </div>
          <div class="col-md-2 col-sm-3 col-xs-6">
            <img src="../img/clients-icon-36.png" />
          </div>
          <div class="col-md-2 col-sm-3 col-xs-6">
            <img src="../img/clients-icon-35.png" />
          </div>
          <div class="col-md-2 col-sm-3 col-xs-6">
            <img src="../img/clients-icon-34.png" />
          </div>
          <div class="col-md-2 col-sm-3 col-xs-6">
            <img src="../img/clients-icon-33.png" />
          </div>
          <div class="col-md-2 col-sm-3 col-xs-6">
            <img src="../img/clients-icon-32.png" />
          </div>
          <div class="col-md-2 col-sm-3 col-xs-6">
            <img src="../img/clients-icon-31.png" />
          </div>
          <div class="col-md-2 col-sm-3 col-xs-6">
            <img src="../img/clients-icon-30.png" />
          </div>
          <div class="col-md-2 col-sm-3 col-xs-6">
            <img src="../img/clients-icon-29.png" />
          </div>
          <div class="col-md-2 col-sm-3 col-xs-6">
            <img src="../img/clients-icon-28.png" />
          </div>
          <div class="col-md-2 col-sm-3 col-xs-6">
            <img src="../img/clients-icon-27.png" />
          </div>
          <div class="col-md-2 col-sm-3 col-xs-6">
            <img src="../img/clients-icon-26.png" />
          </div>
          <div class="col-md-2 col-sm-3 col-xs-6">
            <img src="../img/clients-icon-25.png" />
          </div>
          <div class="col-md-2 col-sm-3 col-xs-6">
            <img src="../img/clients-icon-24.png" />
          </div>
          <div class="col-md-2 col-sm-3 col-xs-6">
            <img src="../img/clients-icon-23.png" />
          </div>
          <div class="col-md-2 col-sm-3 col-xs-6">
            <img src="../img/clients-icon-22.png" />
          </div>
          <div class="col-md-2 col-sm-3 col-xs-6">
            <img src="../img/clients-icon-21.png" />
          </div>
          <div class="col-md-2 col-sm-3 col-xs-6">
            <img src="../img/clients-icon-20.png" />
          </div>
          <div class="col-md-2 col-sm-3 col-xs-6">
            <img src="../img/clients-icon-19.png" />
          </div>
          <div class="col-md-2 col-sm-3 col-xs-6">
            <img src="../img/clients-icon-18.png" />
          </div>
          <div class="col-md-2 col-sm-3 col-xs-6">
            <img src="../img/clients-icon-17.png" />
          </div>
          <div class="col-md-2 col-sm-3 col-xs-6">
            <img src="../img/clients-icon-16.png" />
          </div>
          <div class="col-md-2 col-sm-3 col-xs-6">
            <img src="../img/clients-icon-15.png" />
          </div>
          <div class="col-md-2 col-sm-3 col-xs-6">
            <img src="../img/clients-icon-14.png" />
          </div>
          <div class="col-md-2 col-sm-3 col-xs-6">
            <img src="../img/clients-icon-13.png" />
          </div>
          <div class="col-md-2 col-sm-3 col-xs-6">
            <img src="../img/clients-icon-12.png" />
          </div>
          <div class="col-md-2 col-sm-3 col-xs-6">
            <img src="../img/clients-icon-11.png" />
          </div>
          <div class="col-md-2 col-sm-3 col-xs-6">
            <img src="../img/clients-icon-10.png" />
          </div>
          <div class="col-md-2 col-sm-3 col-xs-6">
            <img src="../img/clients-icon-9.png" />
          </div>
          <div class="col-md-2 col-sm-3 col-xs-6">
            <img src="../img/clients-icon-8.png" />
          </div>
          <div class="col-md-2 col-sm-3 col-xs-6">
            <img src="../img/clients-icon-7.png" />
          </div>
          <div class="col-md-2 col-sm-3 col-xs-6">
            <img src="../img/clients-icon-6.png" />
          </div>
          <div class="col-md-2 col-sm-3 col-xs-6">
            <img src="../img/clients-icon-5.png" />
          </div>
          <div class="col-md-2 col-sm-3 col-xs-6">
            <img src="../img/clients-icon-4.png" />
          </div>
          <div class="col-md-2 col-sm-3 col-xs-6">
            <img src="../img/clients-icon-3.png" />
          </div>
          <div class="col-md-2 col-sm-3 col-xs-6">
            <img src="../img/clients-icon-2.png" />
          </div>
          <div class="col-md-2 col-sm-3 col-xs-6">
            <img src="../img/clients-icon-1.png" />
          </div>
        </div>
      </div>
    </div>
    <div class="row center-xs success">
      <div class="col-md-9 col-xs-12">
        <h3>Success</h3>
        <h2>Stories</h2>
      </div>
      <div class="col-md-9 col-xs-12 case-studies">
        <div class="row">
          <div class="col-md-6 col-xs-12">
            <router-link to="/ruggedian-case-study">
              <img src="../img/ruggedian-main.jpg" />
              <p>Pune Get’s Rugged!</p>
              <p>Explore now</p>
              <span></span>
            </router-link>
            <router-link to="/qaudio-case-study">
              <img src="../img/qaudio-main.jpg" />
              <p>Helping Indians Tune in To Happiness</p>
              <p>Explore now</p>
              <span></span>
            </router-link>
          </div>
          <div class="col-md-6 col-xs-12">
            <router-link to="/lebenor-case-study">
              <img src="../img/lebenor-main.png" />
              <p>Embracing the evolution of living spaces</p>
              <p>Explore now</p>
              <span></span>
            </router-link>
            <router-link to="/ubob-case-study">
              <img src="../img/ubob-main.jpg" />
              <p>Amping it up with Millennials and Vodafone U</p>
              <p>Explore now</p>
              <span></span>
            </router-link>
          </div>
          <div class="col-md-6 col-xs-12">
            <router-link to="/expro-case-study">
              <img src="../img/Expro_banner_Img.jpg" />
              <p>EXPRO !</p>
              <p>Explore now</p>
              <span></span>
            </router-link>
           
          </div>
        </div>
      </div>
    </div>
    <div class="row center-xs last">
      <div class="col-md-9 col-xs-12">
        <p>If you’re looking for fresh and impactful solutions,<br />we’re your guys.</p>
      </div>
    </div>
    <div class="row center-xs contact-btn">
      <div class="col-md-9 col-xs-12 text-center">
        <router-link to="/contact" class="next"><span>Connect to Create</span></router-link>
        <span class="line"></span>
      </div>
    </div>
    <div class="scroll-btn">
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 477.175 477.175" style="enable-background:new 0 0 477.175 477.175;" xml:space="preserve">
        <g>
        	<path d="M360.731,229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1,0s-5.3,13.8,0,19.1l215.5,215.5l-215.5,215.5c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4c3.4,0,6.9-1.3,9.5-4l225.1-225.1C365.931,242.875,365.931,234.275,360.731,229.075z"/>
        </g>
      </svg>
    </div>
  </div>
</div>
</template>

<script>
var jQuery = require('jquery-easing')

var percentInterval

export default {
  name: 'clients',
  data() {
    return {
      isInit: false
    }
  },
  methods: {},
  mounted() {
    var page = this

    var bodyColorTimer = setTimeout(function() {
      jQuery('body').addClass('b-clients')
    }, 1200)

    // Animate digital
    percentInterval = setInterval(function() {
      jQuery('.clients .first h1+span').css({
        'opacity': 0,
        'transform': 'translateX(-30px) translateZ(0)'
      })
      var percentTimer_ = setTimeout(function() {
        jQuery('.clients .first h1+span').css({
          'transform': 'translateX(30px) translateZ(0)',
          'transition': 'none'
        })
        if (jQuery('.clients .first h1+span').html() == 'COMMITTED') {
          jQuery('.clients .first h1+span').html('DIGITAL&nbsp;&nbsp;&nbsp;&nbsp;')
        } else {
          jQuery('.clients .first h1+span').html('COMMITTED')
        }
        var percentTimer_ = setTimeout(function() {
          jQuery('.clients .first h1+span').css({
            'transition': '',
            'opacity': 1,
            'transform': 'translateX(0px) translateZ(0)'
          })
        }, 150)
      }, 1500)
    }, 6000)

    // Split on screen
    jQuery('.split, .clients .icons div:nth-child(2) .row>div').each(function(i, e) {
      var splitTimer = setTimeout(function() {
        jQuery(e).toggleClass('active', jQuery(e).offset().top < jQuery(window).height() - 120)
      }, 1200 + 300 * i)
    })
    jQuery('#app').scroll(function() {
      var d = jQuery(window).height() - 120
      jQuery('.split, .last, .clients .icons div:nth-child(2) .row>div, .success h2, .success h3, .case-studies a').each(function() {
        var top = jQuery(this).offset().top
        jQuery(this).toggleClass('active', top < d)
      })
      jQuery('.contact-btn, .scroll-btn').toggleClass('active', jQuery('#app').scrollTop() + window.innerHeight > jQuery('.page').height() - 90)
    })

    // Scroll button
    jQuery('.scroll-btn').click(function() {
      jQuery('#app').animate({
        scrollTop: 0
      }, 600, 'easeOutQuart')
    })

    var mountTimer = setTimeout(function() {
      page.isInit = true
    }, 1000)

  },
  beforeDestroy() {
    jQuery('#app').unbind('scroll')
    clearInterval(percentInterval)
  }
}
</script>



// WEBPACK FOOTER //
// Clients.vue?a6f5065e